package com.schoolconnect.app.feature.home

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import com.schoolconnect.app.feature.common.featureCatalog

@Composable
fun HomeFeatureRoute(
    homeRoleCode: String = "",
    homeSchoolLabel: String = "iConnect.School",
    homeSchoolId: String = "",
    homeSchoolCode: String = "",
    initialSelectedNavId: String = "dashboard",
    features: List<com.schoolconnect.app.feature.common.FeatureEntry> = featureCatalog,
    onOpenFeature: (String) -> Unit = {},
    onToggleTheme: () -> Unit = {},
    onLogout: () -> Unit = {},
    onHomeRoleChanged: (String, String, String) -> Unit = { _, _, _ -> },
    onBack: () -> Unit
) {
    val viewModel = remember(homeRoleCode, homeSchoolLabel, homeSchoolId, homeSchoolCode, initialSelectedNavId) {
        HomeViewModel(
            homeRoleCode = homeRoleCode,
            homeSchoolLabel = homeSchoolLabel,
            homeSchoolId = homeSchoolId,
            homeSchoolCode = homeSchoolCode,
            initialSelectedNavId = initialSelectedNavId,
            onHomeRoleChanged = onHomeRoleChanged
        )
    }
    val uiState by viewModel.uiState.collectAsState()

    DisposableEffect(viewModel) {
        onDispose { viewModel.clear() }
    }

    HomeScreen(
        state = uiState,
        features = features,
        onEvent = viewModel::onEvent,
        onOpenFeature = onOpenFeature,
        onToggleTheme = onToggleTheme,
        onLogout = onLogout
    )
}
